export default function MbsLogo() {
  return (
    <div className="mbs-panel" data-testid="mbs-logo" role="img" aria-label="MBS Transit Global Logistics — www.mbstransit.com">
      <div className="mbs-top">
        <div className="mbs-logo-title">MBS Transit</div>
      </div>
      <div className="mbs-band">
        <span className="mbs-stripe-red flex-[1]" />
        <span className="mbs-logo-sub">Global Logistics</span>
        <span className="mbs-stripe-red flex-[2.2]" />
      </div>
      <div className="mbs-stripe-navy" />
      <div className="mbs-bottom">
        <span className="mbs-url" data-testid="mbs-logo-url">www.mbstransit.com</span>
      </div>
    </div>
  );
}
